import React from 'react';
import { Collapse, ListItemIcon, ListItemText, MenuItem, MenuList } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';

export const MenuListDrawer = ({ list = [], onMobileOpen = null }) => {
  const [open, setOpen] = React.useState({});

  const handleClick = (itemIndex) => {
    setOpen((prevOpen) => ({
      ...prevOpen,
      [itemIndex]: !prevOpen[itemIndex],
    }));
  };

  const onHandleEscapeSubMenu = (e, index) => {
    if (e?.key === 'Escape') {
      handleClick(index);
      let ele = document.getElementById(`accordion-${index}`);
      ele.focus();
    }
  };

  return (
    <>
      {list.length > 0 &&
        list.map((item, index) => (
          <React.Fragment key={item.label}>
            {!item?.submenu && !item?.external && (
              <MenuItem
                key={item.label}
                component={NavLink}
                to={item.to}
                sx={{ paddingTop: '10px', paddingBottom: '10px' }}
                onClick={(e) => onMobileOpen(false)}
                activeClassName='Mui-selected'
                exact
              >
                <ListItemIcon sx={{ color: 'default.main' }}>{item.icon}</ListItemIcon>
                {item.label}
              </MenuItem>
            )}
            {!item?.submenu && item?.external && (
              <MenuItem
                key={item.label}
                sx={{ paddingTop: '10px', paddingBottom: '10px' }}
                onClick={() => {
                  window.open(item.to, '_blank');
                  if (onMobileOpen) onMobileOpen(false);
                }}
              >
                <ListItemIcon sx={{ color: 'default.main' }}>{item.icon}</ListItemIcon>
                {item.label}
              </MenuItem>
            )}
            {item?.submenu && (
              <>
                <MenuItem
                  key={item.label}
                  sx={{ paddingTop: '10px', paddingBottom: '10px' }}
                  onClick={() => handleClick(index)}
                  aria-controls={open ? `submenu-${index}` : undefined}
                  aria-expanded={open ? 'true' : undefined}
                  id={`accordion-${index}`}
                  tabIndex={index}
                >
                  <ListItemIcon sx={{ color: 'default.main' }}>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.label} />
                  {open[index] ? <ExpandLess /> : <ExpandMore />}
                </MenuItem>

                <Collapse
                  id={`submenu-${index}`}
                  role='region'
                  aria-labelledby={`accordion-${index}`}
                  in={open[index]}
                  timeout='auto'
                  unmountOnExit
                >
                  {item?.submenu?.map((subItem, subIndex) => (
                    <MenuItem
                      key={subItem.label}
                      component={NavLink}
                      to={subItem.to}
                      sx={{ paddingTop: 1, paddingBottom: 1, paddingLeft: 3 }}
                      onClick={(e) => onMobileOpen(false)}
                      onKeyDown={(e) => {
                        onHandleEscapeSubMenu(e, index);
                      }}
                      tabIndex={index + 1}
                      activeClassName='Mui-selected'
                      exact
                    >
                      <ListItemIcon>{subItem.icon}</ListItemIcon>
                      {subItem.label}
                    </MenuItem>
                  ))}
                </Collapse>
              </>
            )}
          </React.Fragment>
        ))}
    </>
  );
};
